// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3aazW","body":"Form_body__23Xio"};